import { apiSlice } from '../api/apiSlice'

export const importApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    importAllData: builder.mutation<void, Uint8Array>({
      query: data => ({
        url: 'import/all',
        method: 'POST',
        body: data,
        headers: { 'Content-Type': 'application/octet-stream' },
      }),
      invalidatesTags: () => [
        { type: 'Worklog', id: 'LIST' },
        { type: 'YearlySummary', id: 'LIST' },
        { type: 'Vacation', id: 'LIST' },
      ],
    }),
    importDetailData: builder.mutation<number, DetailImportDTO>({
      query: data => ({
        url: 'import/custom',
        method: 'POST',
        body: data,
        headers: { 'Content-Type': 'application/json' },
      }),
      invalidatesTags: () => [
        { type: 'Worklog', id: 'LIST' },
        { type: 'YearlySummary', id: 'LIST' },
        { type: 'Vacation', id: 'LIST' },
      ],
    }),
  }),
})

export const { useImportAllDataMutation, useImportDetailDataMutation } = importApiSlice

export interface DetailImportDTO {
  data: string
  employeeId: string
  importType: string
  projectName: string
  overwrite: boolean
  dateFrom: string
  dateTo: string
  extension: string
}
